import { authHeader } from '@/_helpers';
import {userService} from "@/_services/user.service";
import {API_URL} from "../config/app";

const URL = API_URL


export const planService = {
  getAll,
  switchPlan
}

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(URL + "/plans", requestOptions)
    .then(handleResponse)
    .then(response => {

      let data = [];
      response.data.forEach(resp => {
        data.push({
          id: resp.id,
          name: resp.attributes.name,
          role: resp.attributes.role,
          price_per_renew: resp.attributes.price_per_renew,
          interval: resp.attributes.interval,
          credits_per_renew: resp.attributes.credits_per_renew,
          discount: resp.attributes.discount
        });
      })

      return Promise.resolve({
        data
      })
    })
}

function switchPlan(planId, paymentMethod) {
  let formData = new FormData();
  formData.append("plan_id", planId);
  formData.append("payment_method", paymentMethod);

  let headers = authHeader();
  delete headers['Content-Type']

  const requestOptions = {
    method: 'POST',
    headers: headers,
    body: formData
  };

  return fetch(URL + "/plans", requestOptions).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.refreshToken();
        return Promise.reject("Intentando recuperar la sesión");
      }

      const error = (data && data.errors[0].detail) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
